import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

export enum VehicleTab {
  VEHICLE_CHECKS = 'vehicle-checks',
  ALERTS = 'alerts',
}

export const vehicleTabs: ITab[] = [
  {
    label: 'Alerts',
    key: VehicleTab.ALERTS,
  },
  {
    label: 'Vehicle Checks',
    key: VehicleTab.VEHICLE_CHECKS,
  },
];
